(function() {
  'use strict';

  var STATS_URL = 'https://script.google.com/macros/s/AKfycbw42J1SwowdtMWXO708vEKtuftlKo0N4ergkDjGgIl5nF7fGUw4fwY33tIzcT5CstKUIg/exec';

  var form = document.getElementById('dashboard-form');
  var emailInput = document.getElementById('dashboard-email');
  var lookupBtn = document.getElementById('dashboard-lookup-btn');
  var loading = document.getElementById('dashboard-loading');
  var error = document.getElementById('dashboard-error');
  var errorText = document.getElementById('dashboard-error-text');
  var stats = document.getElementById('dashboard-stats');

  if (!form || !emailInput || !lookupBtn) return;

  var nameEl = document.getElementById('dashboard-name');
  var emailDisplayEl = document.getElementById('dashboard-email-display');
  var clicksEl = document.getElementById('dashboard-clicks');
  var detailViewsEl = document.getElementById('dashboard-detailViews');
  var addToCartsEl = document.getElementById('dashboard-addToCarts');
  var purchasesEl = document.getElementById('dashboard-purchases');
  var unitsSoldEl = document.getElementById('dashboard-unitsSold');
  var revenueEl = document.getElementById('dashboard-revenue');
  var commissionEl = document.getElementById('dashboard-commission');
  var commissionRateEl = document.getElementById('dashboard-commission-rate');
  var lastUpdatedEl = document.getElementById('dashboard-last-updated');

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function hideAll() {
    loading.classList.remove('cd-show');
    error.classList.remove('cd-show');
    stats.classList.remove('cd-show');
  }

  function show(el) {
    el.classList.add('cd-show');
  }

  function setLoading(isLoading) {
    lookupBtn.disabled = isLoading;
    lookupBtn.textContent = isLoading ? 'Loading…' : 'View My Stats';
  }

  function formatCurrency(value) {
    var num = Number(value);
    if (!isFinite(num)) num = 0;
    return '$' + num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Accepts either a fractional rate (0.10) or a whole-number percent (10).
  function formatPercent(value) {
    var num = Number(value);
    if (!isFinite(num)) num = 0;
    if (num > 0 && num <= 1) num = num * 100;
    return (Math.round(num * 10) / 10) + '%';
  }

  function formatNumber(value) {
    var num = Number(value);
    if (!isFinite(num)) num = 0;
    return Math.round(num).toLocaleString('en-US');
  }

  function showError(message) {
    hideAll();
    errorText.textContent = message;
    show(error);
  }

  function showStats(data) {
    hideAll();
    nameEl.textContent = data.creatorName || data.name || 'Creator';
    emailDisplayEl.textContent = data.email || '';
    clicksEl.textContent = formatNumber(data.clicks);
    detailViewsEl.textContent = formatNumber(data.detailPageViews);
    addToCartsEl.textContent = formatNumber(data.addToCarts);
    purchasesEl.textContent = formatNumber(data.purchases);
    unitsSoldEl.textContent = formatNumber(data.unitsSold);
    revenueEl.textContent = formatCurrency(data.revenue);
    commissionEl.textContent = formatCurrency(data.commissionEarned);
    commissionRateEl.textContent = 'at ' + formatPercent(data.commissionRate);
    if (data.lastUpdated) {
      lastUpdatedEl.textContent = 'Last updated: ' + data.lastUpdated;
      lastUpdatedEl.style.display = '';
    } else {
      lastUpdatedEl.style.display = 'none';
    }
    show(stats);
  }

  function lookup(email) {
    hideAll();
    setLoading(true);
    show(loading);

    var url = STATS_URL + '?action=stats&email=' + encodeURIComponent(email);
    fetch(url, { method: 'GET' })
      .then(function(res) {
        if (!res.ok) throw new Error('Network error: ' + res.status);
        return res.json();
      })
      .then(function(data) {
        setLoading(false);
        if (!data || typeof data !== 'object') {
          showError('Sorry, something went wrong. Please try again in a moment.');
          return;
        }
        if (data.status === 'success') {
          showStats(data.creator);
        } else if (data.status === 'not_found') {
          showError('No stats found for this email. If you recently joined, your dashboard will be available once your attribution link is set up.');
        } else {
          showError(data.message || 'Sorry, something went wrong. Please try again in a moment.');
        }
      })
      .catch(function() {
        setLoading(false);
        showError('Sorry, something went wrong. Please check your connection and try again.');
      });
  }

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var email = emailInput.value.trim();
    if (!isValidEmail(email)) {
      showError('Please enter a valid email address.');
      emailInput.focus();
      return;
    }
    lookup(email);
  });
})();
